import { ApiErrorData } from '../types/errors';

/**
 * エラーの型検査
 */
export const isApiErrorDataObject = (
  errorData: unknown
): errorData is ApiErrorData => {
  // 型検査のために使用するので意図的に ESLint のルールを逸脱する
  if (
    // eslint-disable-next-line no-prototype-builtins
    errorData?.hasOwnProperty('code') &&
    // eslint-disable-next-line no-prototype-builtins
    errorData?.hasOwnProperty('message')
  ) {
    return true;
  }
  return false;
};
